import { useCallback, useEffect, useState } from "react";
import { fetchVehicleDealFinderDiagnostics } from "../../../../services/vehicleDealFinderApi";
import AdminStatePanel from "../layout/AdminStatePanel";

const VehicleDealFinderDiagnosticsPage = ({ onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setErrorMessage("");
      const result = await fetchVehicleDealFinderDiagnostics();
      setData(result);
    } catch (err) {
      setErrorMessage(err.message || "Unable to load diagnostics.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const d = data?.diagnostics;

  return (
    <div className="admin-dashboard admin-vehicle-deal-finder-dash admin-vehicle-sources-dash--full-width">
      <header className="admin-dashboard__header">
        <div>
          <h1>Vehicle Deal Finder Diagnostics</h1>
          <p className="muted">Why deals appear or are excluded from public Deal Finder sections.</p>
        </div>
        {onClose ? (
          <button type="button" className="crm-btn crm-btn-secondary" onClick={onClose}>
            Close
          </button>
        ) : null}
      </header>

      {errorMessage ? <AdminStatePanel variant="error" message={errorMessage} /> : null}
      {loading ? <p>Loading diagnostics…</p> : null}

      {d ? (
        <div className="admin-summary-cards">
          <div className="admin-summary-card">
            <span>Eligible deals</span>
            <strong>{d.eligibleDeals}</strong>
          </div>
          <div className="admin-summary-card">
            <span>Active listings</span>
            <strong>{d.activeListings}</strong>
          </div>
          <div className="admin-summary-card">
            <span>Excluded (quality)</span>
            <strong>{d.excludedDueToQuality}</strong>
          </div>
          <div className="admin-summary-card">
            <span>Excluded (lifecycle)</span>
            <strong>{d.excludedDueToLifecycle}</strong>
          </div>
          <div className="admin-summary-card">
            <span>Missing fair value</span>
            <strong>{d.missingFairValue}</strong>
          </div>
          <div className="admin-summary-card">
            <span>Missing best value</span>
            <strong>{d.missingBestValueScore}</strong>
          </div>
          <div className="admin-summary-card">
            <span>Canonical groups</span>
            <strong>{d.canonicalGroupedCount}</strong>
          </div>
        </div>
      ) : null}

      {data?.sectionCounts ? (
        <section className="panel-card" style={{ marginTop: "1rem" }}>
          <h2>Section counts</h2>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Section</th>
                <th>Eligible count</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(data.sectionCounts).map(([key, count]) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>{count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ) : null}
    </div>
  );
};

export default VehicleDealFinderDiagnosticsPage;
